// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"ProjectTimeSettings_tableWrapper__I73R+","wrap":"ProjectTimeSettings_wrap__wHa44"};